import React from 'react'

import useUser from 'hooks/useUser'
import { hasRegionalOrAdminAccess } from 'utils/userAccess'

import DealershipFilterBox from '../DealershipFilterBox'
import LeadsFilter from '../LeadsFilter'
import { Container } from './LeadsFilters.styled'

export default function LeadsFilters() {
    const { user } = useUser()

    const shouldDisplayDealershipFilter = hasRegionalOrAdminAccess(
        user?.applicationAccess,
    )

    return (
        <Container>
            {shouldDisplayDealershipFilter && <DealershipFilterBox />}
            <LeadsFilter />
        </Container>
    )
}
